import {
  QUESTIONS_FETCH_REQUEST, QUESTIONS_FETCH_SUCCESS, QUESTIONS_FETCH_FAILURE,
  QUESTION_CREATE_REQUEST, QUESTION_CREATE_SUCCESS, QUESTION_CREATE_FAILURE,
  QUESTION_UPDATE_REQUEST, QUESTION_UPDATE_SUCCESS, QUESTION_UPDATE_FAILURE,
  QUESTION_DELETE_REQUEST, QUESTION_DELETE_SUCCESS, QUESTION_DELETE_FAILURE,
  QUESTION_FETCH_BY_ID_REQUEST, QUESTION_FETCH_BY_ID_SUCCESS, QUESTION_FETCH_BY_ID_FAILURE,
  QUESTIONS_RESET
} from "./QuestionsTypes";

const questionsInitial = {
  questions: [],
  currentQuestion: null,
  loading: false,
  error: null,
  success: false,
  lastFetchedAt: null,
  lastFetchParams: null
};

export const questionsReducer = (state = questionsInitial, action) => {
  switch (action.type) {
    case QUESTIONS_FETCH_REQUEST:
      return { ...state, loading: true, error: null };
    case QUESTIONS_FETCH_SUCCESS:
      return { ...state, loading: false, questions: action.payload, error: null, lastFetchedAt: Date.now(), lastFetchParams: action.fetchParams || null };
    case QUESTIONS_FETCH_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case QUESTION_FETCH_BY_ID_REQUEST:
      return { ...state, loading: true, error: null };
    case QUESTION_FETCH_BY_ID_SUCCESS:
      return { ...state, loading: false, currentQuestion: action.payload, error: null };
    case QUESTION_FETCH_BY_ID_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case QUESTION_CREATE_REQUEST:
      return { ...state, loading: true, error: null, success: false };
    case QUESTION_CREATE_SUCCESS:
      return { ...state, loading: false, questions: [...state.questions, action.payload], success: true };
    case QUESTION_CREATE_FAILURE:
      return { ...state, loading: false, error: action.payload, success: false };

    case QUESTION_UPDATE_REQUEST:
      return { ...state, loading: true, error: null, success: false };
    case QUESTION_UPDATE_SUCCESS:
      return {
        ...state,
        loading: false,
        questions: state.questions.map(q => q.questionId === action.payload.questionId ? { ...q, ...action.payload } : q),
        success: true
      };
    case QUESTION_UPDATE_FAILURE:
      return { ...state, loading: false, error: action.payload, success: false };

    case QUESTION_DELETE_REQUEST:
      return { ...state, loading: true, error: null, success: false };
    case QUESTION_DELETE_SUCCESS:
      return {
        ...state,
        loading: false,
        questions: state.questions.filter(q => q.questionId !== action.payload),
        success: true
      };
    case QUESTION_DELETE_FAILURE:
      return { ...state, loading: false, error: action.payload, success: false };

    case QUESTIONS_RESET:
      return questionsInitial;

    default:
      return state;
  }
};
